module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.29503e9.eot";


//////////////////
// WEBPACK FOOTER
// ./autocomplete-component/src/fonts/Roboto-Regular.eot
// module id = agzZ
// module chunks = 1